import { createContext, useContext } from 'react';

type ImgRectContextType = DOMRect;

export const ImgRectContext = createContext<ImgRectContextType>(null);

export const useImgRectContext = () => useContext(ImgRectContext);
